export default __webpack_public_path__ + "static/media/cert-english-grammar.17891bed.png";